import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Map, MapPin, FileText, Star, Inbox, TrendingUp } from "lucide-react";
import { adminGetStats } from "./adminApi";

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { adminGetStats().then(setStats).catch(() => {}); }, []);

  const cards = [
    { label: "Tours", value: stats?.tours, sub: `${stats?.published_tours || 0} published`, icon: Map, to: "/admin/tours", color: "#7c1d1d" },
    { label: "Destinations", value: stats?.destinations, icon: MapPin, to: "/admin/destinations", color: "#14523d" },
    { label: "Blog Posts", value: stats?.blog_posts, icon: FileText, to: "/admin/blog", color: "#d4af37" },
    { label: "Testimonials", value: stats?.testimonials, icon: Star, to: "/admin/testimonials", color: "#7c1d1d" },
    { label: "Total Enquiries", value: stats?.enquiries, sub: `${stats?.new_enquiries || 0} new`, icon: Inbox, to: "/admin/enquiries", color: "#14523d" },
  ];

  return (
    <div>
      <div className="mb-8">
        <div className="text-[11px] tracking-[0.3em] uppercase text-[#7c1d1d] font-semibold">Dashboard</div>
        <h1 className="font-serif text-4xl text-[#3b1a1a] mt-1">Welcome back</h1>
        <p className="text-[#5a4b4b] mt-2">Here’s what’s happening across your website.</p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-5 gap-4" data-testid="dashboard-stats">
        {cards.map((c) => (
          <Link key={c.label} to={c.to} className="bg-white border border-[#d4af37]/25 hover:border-[#d4af37]/60 p-5 transition-colors group">
            <div className="flex items-center justify-between">
              <span className="w-10 h-10 grid place-items-center text-white" style={{ background: c.color }}><c.icon className="w-5 h-5" /></span>
              <TrendingUp className="w-4 h-4 text-[#d4af37] opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>
            <div className="font-serif text-4xl text-[#3b1a1a] mt-4">{c.value ?? "—"}</div>
            <div className="text-[11px] tracking-[0.15em] uppercase text-[#5a4b4b] mt-1">{c.label}</div>
            {c.sub && <div className="text-[11px] text-[#14523d] mt-1">{c.sub}</div>}
          </Link>
        ))}
      </div>

      {/* Recent enquiries */}
      <div className="mt-10 bg-white border border-[#d4af37]/25">
        <div className="px-6 py-4 border-b border-[#d4af37]/20 flex items-center justify-between">
          <h2 className="font-serif text-2xl text-[#3b1a1a]">Recent Enquiries</h2>
          <Link to="/admin/enquiries" className="text-xs tracking-[0.2em] uppercase text-[#7c1d1d]">View all →</Link>
        </div>
        <div className="divide-y divide-[#d4af37]/15">
          {(stats?.recent_enquiries || []).map((e) => (
            <div key={e.id} className="px-6 py-4 flex items-center justify-between gap-4">
              <div>
                <div className="font-medium text-[#3b1a1a]">{e.name} <span className="text-[#5a4b4b] font-normal">· {e.country}</span></div>
                <div className="text-sm text-[#5a4b4b] clamp-2">{e.preferred_tour || e.message || e.email}</div>
              </div>
              <span className={`text-[10px] tracking-[0.15em] uppercase px-3 py-1 ${e.status === "new" ? "bg-[#7c1d1d] text-white" : e.status === "contacted" ? "bg-[#d4af37] text-[#2d1616]" : "bg-[#14523d] text-white"}`}>{e.status}</span>
            </div>
          ))}
          {(!stats?.recent_enquiries || stats.recent_enquiries.length === 0) && <div className="px-6 py-10 text-center text-[#5a4b4b]">No enquiries yet.</div>}
        </div>
      </div>
    </div>
  );
}
